import LayerAPI from '@/api/layer'
import vue from 'vue'

// initial state
const state = {
  searches: [],
  searchOptions: [],
  searchMode: 'filter'
}

// getters
const getters = {
  getSearchOptions (state) {
    return state.searchOptions
  },
  getSearches (state) {
    return state.searches
  },
  getSearchMode (state) {
    return state.searchMode
  }
}

// actions
const actions = {
  async fetchSearchOptions (store) {
    const response = await LayerAPI.getSearchOptions()
    store.commit('setSearchOptions', response.data)

    return response.data
  },
  setSearchMode (store, data) {
    store.commit('setSearchMode', data)
  },
  setSearches (store, data) {
    store.commit('setSearches', data)
  },
  addSearchItem (store, data) {
    store.commit('addSearchItem', data)
  },
  updateSearchItem (store, data) {
    store.commit('updateSearchItem', data)
  },
  deleteSearchItem (store, index) {
    store.commit('deleteSearchItem', index)
  }
}

// mutations
const mutations = {
  setSearchOptions (state, data) {
    state.searchOptions = data
  },
  setSearches (state, data) {
    state.searches = data
    localStorage.setItem('search.entries', JSON.stringify(state.searches))
  },
  setSearchMode (state, data) {
    state.searchMode = data
    localStorage.setItem('search.mode', JSON.stringify(state.searchMode))
  },
  addSearchItem (state, data) {
    state.searches.push(data)
    localStorage.setItem('search.entries', JSON.stringify(state.searches))
  },
  updateSearchItem (state, data) {
    vue.set(state.searches, data.index, data.data)
    localStorage.setItem('search.entries', JSON.stringify(state.searches))
  },
  deleteSearchItem (state, index) {
    // vue.delete(state.searches, index)
    state.searches.splice(index, 1)
    localStorage.setItem('search.entries', JSON.stringify(state.searches))
  },
  initialise (state) {
    if (localStorage.getItem('search.entries')) {
      state.searches = JSON.parse(localStorage.getItem('search.entries'))
    }
    if (localStorage.getItem('search.mode')) {
      state.searchMode = JSON.parse(localStorage.getItem('search.mode'))
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
